/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticuloModelDto } from '../../models/articulo-model-dto';

export interface InformacionAdicionalControllerObtenerArticulo$Params {

/**
 * UUID del artículo a obtener
 */
  uuidArticulo: string;
}

export function informacionAdicionalControllerObtenerArticulo(http: HttpClient, rootUrl: string, params: InformacionAdicionalControllerObtenerArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticuloModelDto>> {
  const rb = new RequestBuilder(rootUrl, informacionAdicionalControllerObtenerArticulo.PATH, 'get');
  if (params) {
    rb.path('uuidArticulo', params.uuidArticulo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticuloModelDto>;
    })
  );
}

informacionAdicionalControllerObtenerArticulo.PATH = '/api/informacion-adicional/obtener-articulo/{uuidArticulo}';
